import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileArrowLeftIn"><Path d="M12.4141 19L8 23.4141L6.58594 22L8.58594 20H3V18H8.58594L6.58594 16L8 14.5859L12.4141 19Z" fill="currentColor"/><Path d="M12 10H20V22H12.2422L15.2422 19L8 11.7578L4 15.7578V2H12V10Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowLeftIn;
